import React, { useEffect, useState } from 'react'
import { UncontrolledTooltip } from 'reactstrap'
import { fnGetValueByKey } from '../../helpers/functions'
import TextWithTooltip from './TextWithTooltip'
import ElementWithGenericTrigger from '../Utils/ElementWithGenericTrigger'

const CardContextDynamic = ({ contextBlock, isRenderModal = false }) => {
  const childs = contextBlock

  const [rowData, setRowData] = useState([])
  const [, setLoading] = useState(true)
  const [headers, setHeaders] = useState([])
  const [variant, setVariant] = useState('default')

  const getComponent = (item, idx, isUserPhoto = false) => {
    switch (item?.tipo) {
      case 'image':
        const imageUrl = item?.valor

        const imageClass = isUserPhoto
          ? 'img-context-user d-flex align-items-center bg-transparent'
          : 'img-card font-size-32 d-flex align-items-center bg-transparent'
        // const fallbackIconClass = isUserPhoto
        //   ? 'far fa-user-circle img-context-user d-flex align-items-center bg-transparent'
        //   : 'far fa-user-circle img-card font-size-32 d-flex align-items-center bg-transparent'

        return (
          <ElementWithGenericTrigger 
            key={idx}
            elementID={`image-${idx}`}
            elementValue={imageUrl}
            elementType='image-tooltip'
            elementDescription={item?.descricao}
            elementClassName={`${imageClass}`}
            fnInString={item?.acao}
          />
        )
      case 'icone':
        return (
          <ElementWithGenericTrigger 
            key={idx}
            elementID={`icone-${idx}`}
            elementValue={`${item?.valor}`}
            elementType='icon-tooltip'
            elementDescription={item?.descricao}
            fnInString={item?.acao}
          />
        )
      case 'badge':
        return (
          <ElementWithGenericTrigger 
            key={idx}
            elementID={`badge-${idx}`}
            elementValue={imageUrl}
            elementType='badge'
            elementDescription={item?.descricao}
            elementClassName={`${item?.estilo}`}
            fnInString={item?.acao}
          />
        )
      case 'texto':
        return (
          <ElementWithGenericTrigger 
            key={idx}
            elementID={`text-${idx}`}
            elementValue={`${item?.valor}`}
            elementType='icon-tooltip'
            elementDescription={item?.descricao}
            fnInString={item?.acao}
          />
        )
      default:
        return (
          <i
            key={idx}
            className="far fa-user-circle"
            aria-hidden="true"
            title="Tipo de componente desconhecido ou valor ausente"
          />
        )
    }
  }

  const handleGetData = async () => {
    setLoading(true)
    let currentHeaders = []
    let currentVariant = 'default'
    let currentItems = []

    try {      
      const colStr = fnGetValueByKey(childs, 'CONTEXTO_LISTA_COLUNAS')
      currentHeaders = colStr ? JSON.parse(colStr) : []
      setHeaders(currentHeaders)
    } catch (e) {
      console.error('Erro ao parsear CONTEXTO_LISTA_COLUNAS:', e)
    }

    try {
      const variantConfig = fnGetValueByKey(childs, 'CONTEXTO_VARIANT')
      currentVariant = variantConfig === 'bordered' ? 'bordered' : 'default'
      setVariant(currentVariant)
    } catch (e) {
      console.warn('Erro ao definir variant:', e)
    }
      try {
        const resultSet = fnGetValueByKey(childs, 'PROCEDURE_RESULTSET')
        const parsed = resultSet ? JSON.parse(resultSet) : []

        if (parsed.length === 0) {
          setRowData([])
          console.warn('Nenhum item encontrado no resultSet')
        }else{
          currentItems = parsed.map(item => {
            const newItem = { ...item }
            currentHeaders.forEach(header => {
              if (
                header.hasImage === 'True' &&
                typeof newItem[header.field] === 'string'
              ) {
                try {
                  newItem[header.field] = JSON.parse(newItem[header.field])
                } catch (parseError) {
                  console.warn(
                    `Campo ${header.field} não é um JSON válido (resultSet direto):`,
                    parseError
                  )
                  newItem[header.field] = newItem[header.field]
                }
              }
            })
  
            return newItem
          })
          setRowData(currentItems)
        }

      } catch (e) {
        console.error('Erro ao parsear PROCEDURE_RESULTSET:', e)
        setRowData([])
      } finally {
        setLoading(false)
      }
  }

  useEffect(() => {
    if (!childs) return 
    handleGetData()
  }, [childs])

  if (!childs) return 

  const wrapperClass = `card-context-dynamic-wrapper d-flex flex-column ${
    variant === 'bordered' ? 'cb-variant-bordered' : ''
  }`.trim()

  return (
    <div className={wrapperClass}>
      {rowData.map((item, index) => (
        <div
          key={index}
          className={`card-context-dynamic d-flex justify-content-between align-items-start ${isRenderModal ? 'p-3' : 'p-4'} flex-wrap`}
        >
          {headers.map((headerConfig, headerIndex) => {
            console.log('headerConfig', headerConfig)
            const fieldValue = item[headerConfig.field]
            const hasImage = headerConfig.hasImage === 'True'
            const hasHTMLRegex = /<[^>]+>/
            const limitCharacters = headerConfig?.limitCharacters || 14

            const isFirstColumn = headerIndex === 0

            return (
              <div
                key={headerIndex}
                className="card-context-dynamic-item d-flex flex-column flex-wrap"
                style={{
                  width: headerConfig.width,
                  flex: 'none',
                  minWidth: 0
                }}
              >
                <span className={`${isRenderModal ? 'font-size-14 font-w-400': 'font-size-14 font-w-500 mb-1'} text-color-cinza5 flex-wrap`}>
                  {headerConfig.header}
                </span>

                {hasImage ? (
                  <div className="d-flex align-items-center flex-wrap gap-8 text-color-azul1 font-size-14 font-w-600">
                    {Array.isArray(fieldValue) && fieldValue.length > 0 ? (
                      fieldValue.map((innerItem, innerIndex) =>
                        getComponent(
                          innerItem,
                          `${index}-${headerIndex}-${innerIndex}`,
                          isFirstColumn
                        )
                      )
                    ) : fieldValue && typeof fieldValue === 'object' ? (
                      getComponent(
                        fieldValue,
                        `${index}-${headerIndex}-single`,
                        isFirstColumn
                      )
                    ) : (
                      <i
                        className={`far fa-user-circle user-photo-label font-size-20 ${
                          isFirstColumn ? 'img-context-user' : ''
                        }`}
                        aria-hidden="true"
                        title="Foto de perfil não disponível"
                      />
                    )}
                  </div>
                ) : (
                  fieldValue &&
                  fieldValue !== '' &&
                  (hasHTMLRegex.test(fieldValue) ? (
                    <div
                      className=" flex-wrap"
                      dangerouslySetInnerHTML={{ __html: fieldValue }}
                    ></div>
                  ) : (
                    <span
                      id={isFirstColumn && item.Descricao_Objeto ? `Tooltip-doc-${index}` : undefined}
                      className={`text-color-azul1 ${isRenderModal ? "font-size-14" : " font-size-16"} font-w-600 flex-wrap d-inline-flex align-items-center gap-2`}
                    >
                      {isFirstColumn && item.Icone_Documento && (
                        <i className={item.Icone_Documento} aria-hidden="true"></i>
                      )}
                      <TextWithTooltip id={`context-${headerIndex}`} textFull={fieldValue} text={(fieldValue?.length > limitCharacters ? fieldValue.slice(0, limitCharacters) + '...' : fieldValue)} />
                      {isFirstColumn && item.Descricao_Objeto && (
                        <UncontrolledTooltip
                          placement="top"
                          target={`Tooltip-doc-${index}`}
                          className="tooltip-table-dinamic"
                        >
                          {item.Descricao_Objeto}
                        </UncontrolledTooltip>
                      )}
                    </span>
                  ))
                )}
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}

export default CardContextDynamic
